export default "__VITE_ASSET__CsSielc1__"